module.exports = __webpack_public_path__ + "assets/img/20@3x.1c957322.png";